<a
  class="footnote-tooltip"
  [href]="'#' + footnoteId()"
  [attr.aria-label]="
    'pages.articles.footnoteReference' | translate: { number: footnoteNumber() }
  "
  [attr.data-footnote]="footnoteNumber()"
  (click)="onSelect($event)"
  (keydown.enter)="onSelect($event)"
  tabindex="0"
>
  <sup [id]="referenceId()">
    <span [innerText]="footnoteNumber()"></span>
  </sup>
  <span
    class="footnote-tooltip-content"
    [innerText]="content() | htmlToPlaintext"
  ></span>
</a>
